import { useState, useEffect } from 'react';
import { FileText, Eye } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';

export default function Exams() {
  const [exams, setExams] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => { loadExams(); }, []);

  const loadExams = async () => {
    try {
      // Admin endpoint to get all exams
      const res = await api.get('/admin/exams');
      if (res.data.success) setExams(res.data.exams || []);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const openExamPage = (exam) => {
    navigate(`/admin/exams/${exam.exam_id}`);
  };

  if (loading) {
    return <div className="flex items-center justify-center h-64"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div></div>;
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-800">Exams Overview</h1>
        <p className="text-gray-500">View all exams created by lecturers</p>
      </div>

      <div>
        <div className="bg-white rounded-xl shadow-sm border border-gray-100">
          <div className="p-4 border-b border-gray-100">
            <h3 className="font-semibold text-gray-800">All Exams ({exams.length})</h3>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-gray-50">
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Exam</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Subject</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Grade</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Total Marks</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Date</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {exams.map((exam) => (
                  <tr key={exam.exam_id} className={`hover:bg-gray-50 cursor-pointer`} onClick={() => openExamPage(exam)}>
                    <td className="px-4 py-3">
                      <div className="flex items-center gap-3">
                        <div className="p-2 bg-pink-100 rounded-lg">
                          <FileText className="w-4 h-4 text-pink-600" />
                        </div>
                        <span className="font-medium text-gray-800">{exam.exam_name}</span>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-gray-600">{exam.subject_name}</td>
                    <td className="px-4 py-3">
                      <span className="px-2 py-1 bg-blue-50 text-blue-600 rounded-full text-xs">{exam.grade_name}</span>
                    </td>
                    <td className="px-4 py-3 text-gray-600">{exam.total_marks}</td>
                    <td className="px-4 py-3 text-gray-600">{exam.exam_date ? new Date(exam.exam_date).toLocaleDateString() : '-'}</td>
                    <td className="px-4 py-3">
                      <button onClick={(e) => { e.stopPropagation(); openExamPage(exam); }} className="p-2 hover:bg-indigo-50 text-indigo-600 rounded-lg">
                        <Eye className="w-4 h-4" />
                      </button>
                    </td>
                  </tr>
                ))}
                {exams.length === 0 && (
                  <tr><td colSpan="6" className="px-4 py-8 text-center text-gray-400">No exams created yet</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
